"use client"; // Obrigatório se você estiver usando o App Router do Next.js moderno

import { useState } from 'react';

export default function QrCodeManager() {
  const [qrCode, setQrCode] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGenerateQrCode = async () => {
    setLoading(true);
    setError(null);
    setQrCode(null);
    setConnected(false);

    try {
      // ATENÇÃO: Substitua a URL abaixo pela URL real do seu backend NestJS!
      // Se o seu NestJS roda na porta 3000 e o Next na 3001, coloque a porta do Nest.
      const response = await fetch('https://vip.newit.com.br/api/evolution/qrcode/newit-oficial');
      const data = await response.json();

      if (data.success) {
        if (data.qrcode) {
          setQrCode(data.qrcode);
        } else if (data.connected) {
          setConnected(true);
        }
      } else {
        setError(data.message || 'Erro ao gerar o QR Code no motor.');
      }
    } catch (err) {
      console.error(err);
      setError('Falha de comunicação com o servidor VIP.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 bg-gray-900 rounded-2xl shadow-2xl max-w-md mx-auto border border-gray-700 mt-10">
      <h2 className="text-2xl font-bold text-white mb-2">🚗 Conexão Ferrari</h2>
      <p className="text-gray-400 text-sm mb-6 text-center">
        Ligue o motor Baileys e escaneie o código para sincronizar seu WhatsApp.
      </p>

      {/* TELA DE LOADING (Os 8 segundos de respiro) */}
      {loading && (
        <div className="flex flex-col items-center space-y-4">
          <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-green-400 font-semibold animate-pulse">
            Aquecendo o motor (Pode levar até 10s)...
          </p>
        </div>
      )}

      {/* MENSAGEM DE ERRO */}
      {error && !loading && (
        <div className="bg-red-900/50 border border-red-500 text-red-200 px-4 py-3 rounded-lg text-center mb-4 w-full">
          ❌ {error}
        </div>
      )}

      {/* SUCESSO - JÁ CONECTADO */}
      {connected && !loading && (
        <div className="flex flex-col items-center">
          <div className="bg-green-500/20 p-4 rounded-full mb-3">
            <span className="text-5xl">✅</span>
          </div>
          <p className="text-green-400 font-bold text-lg">WhatsApp Online e Pronto!</p>
          <p className="text-gray-400 text-sm text-center mt-1">O motor já está roncando.</p>
        </div>
      )}

      {/* EXIBIÇÃO DO QR CODE */}
      {qrCode && !loading && (
        <div className="flex flex-col items-center bg-white p-4 rounded-xl shadow-inner">
          <img 
            src={qrCode} 
            alt="WhatsApp QR Code" 
            className="w-64 h-64 object-contain"
          />
          <p className="text-gray-800 font-bold mt-4">Escaneie com o WhatsApp</p>
        </div>
      )}

      {/* BOTÃO MÁGICO */}
      {!loading && !qrCode && !connected && (
        <button
          onClick={handleGenerateQrCode}
          className="mt-4 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-400 hover:to-emerald-500 text-white font-bold rounded-lg shadow-lg transform transition hover:scale-105 active:scale-95 w-full"
        >
          🔑 Gerar QR Code VIP
        </button>
      )}
    </div>
  );
}